export const addressesTypeOptions = [
  { value: '', label: '' },
  { value: 'Residencial', label: 'Residencial' },
  { value: 'Comercial', label: 'Comercial' }
]

export const CEP_LENGTH = 8
